// extracted by mini-css-extract-plugin
export default {"layout":"style_layout__ajrVS","header":"style_header__542bh","content":"style_content__aI5sO"};